import React from 'react';
import { ListItemButton, styled } from '@mui/material';
import { listItemButtonClasses } from '@mui/material/ListItemButton';
import { listItemIconClasses } from '@mui/material/ListItemIcon';
import { listItemTextClasses } from '@mui/material/ListItemText';
import { primaryButtonPseudoElementStyles } from 'common/theme/button/sharedButtonStyles';

const StyledMainMenuButton = styled(({ iconOnly, ...otherProps }) => (
  <ListItemButton {...otherProps} />
))(({ iconOnly, theme }) => ({
  borderRadius: '13px',
  justifyContent: iconOnly ? 'center' : 'flex-start',
  minHeight: 46,
  position: 'relative',
  transition: 'transform 200ms cubic-bezier(0.32, 0.72, 0, 1)',
  '&:active': {
    transform: 'scale(0.98)'
  },
  // Velo neutro para hover, estilo Spotify. Mode-aware: en CLARO el velo blanco
  // es invisible sobre el sidebar claro, así que se usa un velo OSCURO.
  '&::before': {
    background: theme.palette.mode === 'light' ? 'rgba(17, 21, 27, 0.06)' : 'rgba(255, 255, 255, 0.08)',
    borderRadius: '13px',
    ...primaryButtonPseudoElementStyles(theme)
  },
  [`& .${listItemTextClasses.root}, & .${listItemIconClasses.root}`]: {
    zIndex: 1
  },
  '&:hover::before': {
    opacity: 1
  },
  // Activo: relleno gris NEUTRO (sin dorado) — gris sobre negro en oscuro,
  // gris sobre blanco en claro. El dorado queda para microacentos.
  [`&.${listItemButtonClasses.selected}`]: {
    backgroundColor: theme.palette.selected.bg,
    [`& .${listItemTextClasses.root}, & .${listItemIconClasses.root}`]: {
      color: theme.palette.selected.fg
    },
    '&:hover': {
      backgroundColor: theme.palette.selected.bg
    }
  }
}));

export default StyledMainMenuButton;
